import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <div>
        <div className='footer'>
                <div className="footerdiv">
                    <div className="footerleft">
                        <h3>CHATAPP</h3>
                        <p><Link className='ulLink' to="/about">About</Link> </p>
                        <p><Link className='ulLink' to="/contact">Contact</Link> </p>
                    </div>
                    <div className="footermiddle">
                        <h3>HELP</h3>
                        <p><Link className='ulLink' to="/about">Help</Link> </p>
                        <p><Link className='ulLink' to="/contact">Privacy Policy</Link> </p>
                    </div>
                    <div className="footerright">
                        <h3>COMPANY</h3>
                        <p><Link className='ulLink' to="/about">Blog</Link> </p>
                    </div>
                </div>
            </div>
            <div className="copyright">
                2022 © ChatApp LLC
            </div>
    </div>
  )
}

export default Footer